import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { CheckCardBase } from '../internal/CheckCardBase/CheckCardBase';
import { PureCheckbox } from '../PureCheckbox/PureCheckbox';
export var CheckboxCard = forwardRef(function (props, ref) {
    return React.createElement(CheckCardBase, __assign({}, props, { ref: ref, CheckComponent: PureCheckbox }));
});
//# sourceMappingURL=CheckboxCard.js.map